import { getFileAttributes } from '../..';
import { getMimeTypeFromFilename } from '../../../utils';
import { getPrimaryErrorReason, getSecondaryErrorReason, getErrorDetail } from '../../../errors';
export var createZipEntryLoadFailedEvent = function createZipEntryLoadFailedEvent(fileState, error, zipEntry) {
  var _getFileAttributes = getFileAttributes(fileState),
    fileId = _getFileAttributes.fileId,
    fileMediatype = _getFileAttributes.fileMediatype,
    fileMimetype = _getFileAttributes.fileMimetype,
    fileSize = _getFileAttributes.fileSize,
    fileStatus = _getFileAttributes.fileStatus;
  return {
    eventType: 'operational',
    actionSubject: 'mediaFile',
    action: 'zipEntryLoadFailed',
    attributes: {
      status: 'fail',
      failReason: getPrimaryErrorReason(error),
      error: getSecondaryErrorReason(error),
      errorDetail: getErrorDetail(error),
      fileAttributes: {
        fileId: fileId,
        fileMediatype: fileMediatype,
        fileMimetype: fileMimetype,
        fileSize: fileSize,
        fileStatus: fileStatus
      },
      size: zipEntry ? zipEntry.size : -1,
      encrypted: zipEntry ? zipEntry.encrypted : false,
      compressedSize: zipEntry ? zipEntry.compressedSize : -1,
      mimeType: zipEntry ? getMimeTypeFromFilename(zipEntry.name) : 'undefined'
    }
  };
};